<template>

    <div class="w-full">

        <nav id="header" class="bg-white fixed w-full z-10 top-0 shadow px-4" style="min-height:56px">

			<div class="w-full container mx-auto flex flex-wrap items-center mt-0 pt-3 pb-3 md:pb-0">
					
				<div class="w-1/2 pl-2 md:pl-0">
					<a class="text-gray-900 text-base xl:text-xl no-underline hover:no-underline font-bold" href="#"> 
						Viral News Service
					</a>
				</div>
				<div class="w-1/2 pr-0">
					<div class="flex relative inline-block float-right font-semibold">
						<div class="block">
							<span>Media Preview</span>
						</div>
					</div>
				</div>
			</div>
		</nav>
		<div class="w-full px-4">

            <!-- loading -->
            <div class="w-full container mx-auto flex flex-wrap items-center pt-16 lg:pt-24 text-center" v-if="loading">
                <div class="mx-auto" colspan="4">
                    <h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
                </div>
            </div>

            <!-- missing details -->
			<div class="w-full container mx-auto flex flex-wrap items-center pb-3 md:pb-0 pt-16 lg:pt-24 text-center" v-if="query.mailing == undefined || query.user == undefined || params.id == undefined">
				<h2 class="text-lg mx-auto">Video not found. Please make sure you have the <strong> entire url</strong>.</h2>
			</div>

            <!-- request details found -->
            <div class="w-full container mx-auto flex flex-wrap items-center pb-3 md:pb-0 pt-20" v-if="(query.mailing !== undefined && query.user !== undefined && params.id !== undefined) && loading == false">
                <div class="w-full flex items-center border-b-2 border-grey-lighter pb-2 mb-3 relative">
                    <div class="bg-blue-700 text-white px-2 py-1 rounded block">${{ videoDetails.price }}</div>
                    <h3 class="font-bold pl-4 text-xl">{{ videoDetails.title }}</h3>
                    <span class="float-none block absolute top-0 right-0" :title="videoDetails.created_at.date | displayLocalDateTime" v-tippy>{{ videoDetails.created_at.date | timeAgo }}</span>
                </div>

                <!-- embargo -->
                <div class="w-full bg-red-600 shadow-md px-4 py-3 text-left text-white mb-3" v-if="videoDetails.embargo !== null">
                    <p class="font-bold">There is an embargo for this video in the <strong>{{ videoDetails.embargo }}</strong> market.</p>
                </div>
				
                <!-- user in network purchased -->
                <div class="w-full bg-blue-700 shadow-md px-4 py-3 text-left text-white mb-3" v-if="videoDetails.sale !== null">
                    <strong>Purchase Notice: </strong> A member of your network has already purchased this video. You may download it again without it constituting as a purchase.
                </div>


                <!-- video details -->
                <div class="w-full mb-2" v-if="videoDetails.youtube_id !== null">
                    <YouTubePlayer :youtube_id="videoDetails.youtube_id" />
                    <div class="bg-red-600 px-4 py-3 text-white">
                        <span>
                            <i class="fab fa-youtube mr-2"></i> The preview is also available directly on YouTube as well by following this link: <a class="font-bold" :href="'https://youtube.com/watch?v=' + videoDetails.youtube_id" target="_blank">https://youtube.com/watch?v={{ videoDetails.youtube_id }}</a>
                        </span>
                    </div>
                </div>

                <div class="w-full mb-2" v-if="videoDetails.rating !== null">
                    <strong>Rating:</strong> <br/>
                    <StarRating :id="videoDetails.video_id" :rating="videoDetails.rating" />
                </div>

                <div class="w-full mb-2">
                    <strong>Location(s):</strong> <br/>
                    {{ videoDetails.locations | printLocations}}
                </div>

                <div class="w-full mb-2">
                    <strong>Description:</strong> <br/>
                    {{ videoDetails.description }}
                </div>

                <div class="w-full mb-2">
                    <strong>Credit:</strong> <br/>
                    {{ videoDetails.user_credit }} <br/>
                </div>

                <div class="w-full text-center mt-4">
                    <button class="bg-green-600 text-white rounded px-3 py-1" v-on:click="purchaseAndDownload" v-if="videoDetails.sale == null">
                        <i class="fa fa-download mr-2"></i> Purchase and Download Video
                    </button>
                    <button class="bg-blue-700 text-white rounded px-3 py-1" v-on:click="redownloadVideo" v-if="videoDetails.sale !== null">
                        <i class="fa fa-download mr-2"></i> Redownload Video
                    </button>
                </div>

			</div>

		</div>

    </div>

</template>

<script>

    import { EventBus } from '../../utils/events';
    import * as Config from '../../config'
    import { mapState, mapGetters } from 'vuex';

    import moment from 'moment';

    import YouTubePlayer from '@/components/general/YouTubePlayer'
    import StarRating from '@/components/general/StarRating'

	export default {
		data () {
			return {
                query: this.$route.query,
                params: this.$route.params,
                videoDetails: null,
                loading: true
			}
        },
        components: {
            YouTubePlayer,
            StarRating
        },
        mounted() {
            this.getVideoListing();
        },
        methods: {
            getVideoListing() {
                this.$http.get(Config.apiPath + "/api/v2/media/preview?upload=" + this.params.id + "&mailing=" + this.query.mailing + "&email=" + encodeURIComponent(this.query.user))
                    .then((response) => {
                        this.$set(this, 'videoDetails', response.data)
                        this.$set(this, 'loading', false)
                    });
            },

            purchaseAndDownload() {
                var _this = this;

                this.$swal({
                    title: 'Continue?',
                    text: "Downloading this file constitutes a purchase. If your network downloads this file and does not use it, notify viralnewsservice@gmail.com within 24 hours to have the charge voided.",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, purchase and download.'
                }).then((result) => {
                    if (result.value) {

                        var data = {
                            upload_id: this.params.id,
                            mailing: this.query.mailing,
                            email: this.query.user,
                        }

                        this.$http.post(Config.apiPath + "/api/v2/media/preview/purchase", data)
                            .then((response) => {
                                
                                var link = document.createElement('a');
                                document.body.appendChild(link);
                                link.href = response.data;
                                link.click();
                                document.body.removeChild(link);

                                _this.$swal(
                                    'All good!',
                                    'The video download has started.',
                                    'success'
                                )

                            })
                    }

                });
            },

            redownloadVideo() {
                var _this = this;
                var data = {
                    upload: this.params.id,
                    mailing: this.query.mailing,
                    email: this.query.user,
                }

                this.$http.post(Config.apiPath + "/api/v2/media/preview/download", data)
                    .then((response) => {
                        
                        var link = document.createElement('a');
                        document.body.appendChild(link);
                        link.href = response.data;
                        link.click();
                        document.body.removeChild(link);

                        _this.$swal(
                            'All good!',
                            'The video download has started.',
                            'success'
                        )

                    })
            },

        },
        filters: {
            printLocations: function(data) {
                if(data !== null && data !== undefined) {
                    var string = "";
                    for(var i=0; i<data.length; i++) {
                        string = string + data[i];
        
                        if(i !== data.length - 1) {
                            string = string + ", ";
                        }
                    }
                    return string;
                }
            },
            timeAgo: function(date) {
                return moment.utc(date).fromNow();
            },
            displayLocalDateTime: function(date) {
                return moment.utc(date).local().format('MMMM Do YYYY, h:mm a');
            }
        }
	}
</script>